import InternalLogin from "./InternalLogin";

export default InternalLogin;
